import { createCacheStore } from '@lib/utils/cache';
import { EmployeeFinanceService } from '@api/EmployeeFinanceService';

/** Cached EmployeeFinanceService.getEmployeeWages(departmentId) reads. */
export const employeeWagesCache = createCacheStore(
    'employeeFinance/employeeWages',
    EmployeeFinanceService.getEmployeeWages,
);

/** Drops the cached employee wages of a department (after wage saves). */
export const invalidateEmployeeWages = (departmentId: string): void => {
    employeeWagesCache.invalidate(departmentId);
};
